import { EntidadeBase } from 'hay-core-react';
class GrupoPermissaoModel extends EntidadeBase {
  constructor() {
    super('grupopermissao');
  }
}

export default new GrupoPermissaoModel();
